import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCalendarRemove4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCalendarRemove4"><Path fillRule="evenodd" clipRule="evenodd" d="M7 4H3V21H21V4H17V2H15.5V4H8.5V2H7V4ZM9.49802 8.93934L8.43736 10L10.9392 12.5018L8.43934 15.0017L9.5 16.0623L11.9998 13.5625L14.4997 16.0623L15.5603 15.0017L13.0605 12.5018L15.5623 10L14.5017 8.93934L11.9998 11.4412L9.49802 8.93934Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCalendarRemove4;
